import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import Image1 from '../assets/webp/card1.webp';
import Image2 from '../assets/webp/card2.webp';
import Image3 from '../assets/webp/card3.webp';
import Image4 from '../assets/webp/card4.webp';

const baseStyles = {
  containerLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "1rem",
    borderRadius: "8px",
  },
  containerRight: {
    padding: "1rem",
  },
  title: {
    display: "flex",
    alignItems: "flex-start",
  },
  DescriptionA: {
    display: "block",
    textAlign: "left",
  },
  DescriptionB: {
    display: "block",
    textAlign: "left",
  },
  DescriptionC: {
    display: "block",
    textAlign: "center",
    paddingTop: "3%",
  },
  DescriptionI: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%"
  },
};

// Mapeo de imágenes por ID
const images = {
  3: <img src={Image1} alt="Image" className="lg:max-h-full sm:max-h-[150px]" style={{ width: "80%", height: "auto" }} />,
  4: <img src={Image2} alt="Image" className="lg:max-h-full sm:max-h-[150px]" style={{ width: "60%", height: "auto" }} />,
  5: <img src={Image3} alt="Image" className="lg:max-h-full sm:max-h-[150px]" style={{ width: "80%", height: "auto" }} />,
  6: <img src={Image4} className="lg:max-w-full sm:max-w-[150px]" style={{ width: "auto", height: "100%" }} alt="Image" />,
};

const Flashcard = ({ selectedFeatureId, onClose }) => {
  const { t } = useTranslation();

  if (!selectedFeatureId) return null;

  // Obtiene los textos traducidos para la flashcard correspondiente
  const data = t(`flashcard.${selectedFeatureId}`, { returnObjects: true });

  // Si no hay datos para el ID, no muestra nada
  if (!data) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div className="md:w-3/5"
        style={{
          overflow: "Auto",
          background: "#FFF",
          borderRadius: "10px",
          maxWidth: "1000px",
          maxHeight: "90vh",
          margin: "30px",
          padding: "30px",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25), 4px 0px 4px 0px rgba(0, 0, 0, 0.25), -4px 0px 4px 0px rgba(0, 0, 0, 0.25)"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "20px",
          }}
        >
          {/* Botón de cerrar */}
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30px"
              height="30px"
              viewBox="0 0 28 28"
              fill="none"
            >
              <circle
                cx="14"
                cy="14"
                r="12.5"
                stroke="#FF00B1"
                strokeWidth="3"
              />
              <path
                d="M7.95154 7.95166L20.0003 20.0004M20.0003 7.95166L7.95154 20.0004"
                stroke="#FF00B1"
                strokeWidth="3"
              />
            </svg>
          </button>
        </div>
        <div>
          <div style={baseStyles.container || {}}>
            <h3 className="font-archivo ft-title mb-2" style={baseStyles.title || {}}>{data.title}</h3>
            <p className="text-secondary ft-p font-sans text-left break-words block whitespace-normal" style={baseStyles.DescriptionA || {}}>{parse(data.descriptionA)}</p>
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div style={baseStyles.containerLeft || {}}>
                <p className="text-secondary ft-p font-sans text-left break-words block whitespace-normal" style={baseStyles.DescriptionB || {}}>{parse(data.descriptionB)}</p>
                <p className="ft-p font-sans text-center justify-center break-words block whitespace-normal text-primary" style={baseStyles.DescriptionC || {}}>{parse(data.descriptionC)}</p>
              </div>
              <div style={baseStyles.containerRight || {}}>
                <div style={baseStyles.DescriptionI || {}}>{images[selectedFeatureId]}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Flashcard;
